import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { ThemeProvider } from 'react-css-themr';
import {
  savePhaseItem,
  deletePhaseItem,
  copyLaborItemsToLaborSheet,
} from 'actionCreators/phase_items';
import MessageBox from 'components/MessageBox';
import { can } from '../../../../../../../../services';
import { getRole } from '../../../../../../../../reducers';
import { requestPayRateLineItemList } from 'actionCreators/dropdown_lists';
import getLineItemTotal from '../../../../../../../../selectors/lineItemTotal';
import LineItemTable from 'components/LineItemTable';
import ContractorLaborRow from 'contractorLaborRow';
import ApproveLaborModal from 'approveLaborModal';
import LaborSheetType from 'types/laborSheet';
import S from 'components/CollapsableCard/styles.scss';
import laborTableStyles from './laborTables.scss';
import { linkTo } from 'helpers/url';
import { FIXED_LINE_ITEMS } from 'config/constants';
import moment from 'moment';

const LINE_ITEM_TYPE = 'contractorLineItems';

const theme = { CollapsableCard: laborTableStyles };

class ContractorLaborTable extends Component {
  state = { approveModalActive: false, errors: {} }

  setLPATutorialId = status => (['Pending Review', 'Not Payable'].includes(status) ? 'installerPayTutorial2' : '');

  getNewLineItem = () => ({
    id: -1,
    line_item_id: null,
    item_number: '',
    description: '',
    quantity: 1,
    price: 0,
    total: 0,
    note: '',
  });

  handleDelete = lineItemId => this.props.deletePhaseItem(this.props.phaseId, {
    id: lineItemId,
    labor_sheet_id: this.props.laborSheet.id,
  }, LINE_ITEM_TYPE);

  handleSave = (lineItem) => {
    const errors = {};
    if (this.isCustom(lineItem.item_number) && (lineItem.note == null || lineItem.note === '')) {
      errors.note = ["Note can't be blank on a custom item"];
      Object.assign(errors);
      this.setState({ errors });
      return;
    }
    this.setState({ errors });
    const newLineItem = { ...lineItem };
    if (!Object.prototype.hasOwnProperty.call(lineItem, 'labor_sheet_id')) {
      newLineItem.labor_sheet_id = this.props.laborSheet.id;
    }
    this.props.savePhaseItem(this.props.phaseId, newLineItem, LINE_ITEM_TYPE);
  }

  requestLineItemOptions = () => {
    const { laborSheet, laborSheet: { assignee } } = this.props;
    this.props.requestPayRateLineItemList(assignee.kind, assignee.id, laborSheet.id);
  }

  copyLaborItems = () =>
    this.props.copyLaborItemsToLaborSheet(this.props.phaseId, this.props.laborSheet.id);

  isCustom = val => (window.SPOT.custom_items.includes(val) || false);

  isClosed = laborSheet => ((!can(this.props.role, 'manage_closed', 'labor_sheet') &&
    ((laborSheet.status === 'Approved by Contractor' && this.props.phaseType !== 'Assessment') ||
     laborSheet.status === 'Recorded')) || false);

  isApproved = laborSheet => ((laborSheet.status === 'Approved by Contractor' || laborSheet.status === 'Recorded') || false);

  determineCanViewTotal = () => can(this.props.role, 'view', 'labor_total');

  handleApproveClick = () => this.setState({ approveModalActive: true })
  handleApproveClose = () => this.setState({ approveModalActive: false })

  handleFixedOptions = options => (options || []).map((o) => {
    const editedOption = o;
    const pricedItem = FIXED_LINE_ITEMS.find(i => i.label === o.label) || null;
    if (pricedItem) {
      editedOption.price = pricedItem.price;
      editedOption.fixedPrice = true;
      if (pricedItem.total) {
        editedOption.total = pricedItem.total;
        editedOption.fixedTotal = true;
      }
    }
    return editedOption;
  });

  handleFixedItem = (item) => {
    const editedItem = { ...item };
    const fixedItem = FIXED_LINE_ITEMS.find(i =>
      i.label === item.item_number.concat(' - ', item.description)) || null;
    if (fixedItem) {
      editedItem.fixedPrice = true;
      if (fixedItem.total) editedItem.fixedTotal = true;
    }
    return editedItem;
  };

  determineAction = (target, icon, text, className = null) => {
    const source = { icon, text, toolTipMessage: text === 'Not Yet Approvable' ? 'Cannot approve before appointment starts' : '' };
    if (className) source.className = className;
    return Object.assign(target, source);
  }

  render = () => {
    const { laborSheet, lineItemOptions, refreshList, total, index,
            phaseType, filterLineItems, surfaceType, editable, lpa, phaseSource,
            phaseId, role, contractorTableApproved, appointmentStartDate } = this.props;
    const editableActions = [];
    const formError = Object.keys(this.state.errors).length > 0;
    if (laborSheet.payable) {
      editableActions.push({ icon: 'content_copy', text: 'Copy Labor Lines', onClick: this.copyLaborItems });
    }
    let readOnly = (!editable || (!contractorTableApproved && phaseType !== 'Assessment') || this.isClosed(laborSheet, lpa));
    const isApproved = this.isApproved(laborSheet);
    const actions = [{ onClick: this.handleApproveClick }];
    if ((laborSheet.status === 'Approved by Contractor' && laborSheet.signed_document_id) ||
        (laborSheet.status !== 'Approved by Contractor' &&
         laborSheet.status !== 'Not Payable' &&
         laborSheet.status !== 'Pending Review')) {
      actions[0] = this.determineAction(actions[0], 'assignment_turned_in', 'Approved');
      readOnly = true;
    } else if (laborSheet.status === 'Not Payable') {
      actions[0] = this.determineAction(actions[0], 'assignment_late', 'Not Payable');
    } else if (moment().isBefore(moment(appointmentStartDate, 'YYYY/MM/DD'), 'day')) {
      actions[0] = this.determineAction(actions[0], 'assignment_late', 'Not Yet Approvable');
    } else {
      actions[0] = this.determineAction(actions[0], 'assignment', 'Approve', S.save);
    }
    const title = (<Link
      to={linkTo(laborSheet.assignee)}
      className={laborTableStyles.cardLink}
      target="_blank"
    >Labor {index}: {laborSheet.assignee.name}</Link>);
    const canViewTotal = this.determineCanViewTotal();
    const lineItems = laborSheet.line_items || [];
    const hasExistingLineItems = lineItems.length > 0;
    const isIfiAssessmentCustomLaborFlow = phaseType === 'Assessment' && phaseSource === 'IFI';
    const shouldShowPlaceholderRow = isIfiAssessmentCustomLaborFlow && !readOnly;
    const lineItemsForTable = (hasExistingLineItems || !shouldShowPlaceholderRow) ?
      lineItems :
      [this.getNewLineItem()];
    return (<ThemeProvider theme={theme}>
      <div id={this.setLPATutorialId(laborSheet.status)}>
        <ApproveLaborModal
          phaseId={Number(phaseId)}
          laborSheetId={laborSheet.id}
          active={this.state.approveModalActive}
          onClose={this.handleApproveClose}
        />
        <LineItemTable
          actionBtnPrefix="laborSheet_"
          title={title}
          requestLineItemList={this.requestLineItemOptions}
          refreshList={refreshList}
          total={total}
          actions={actions}
          editableActions={editableActions}
          hasCreatableRow={editable}
          readOnly={readOnly}
          canViewTotal={canViewTotal}
          accountingTable
        >
          {lineItemsForTable.map(item => <ContractorLaborRow
            key={item.id}
            onSave={this.handleSave}
            onDelete={this.handleDelete}
            isCustom={this.isCustom}
            lineItem={item.id > 0 ? this.handleFixedItem(item) : item}
            lineItemOptions={this.handleFixedOptions(lineItemOptions[laborSheet.id])}
            lpa={lpa}
            role={role}
            isApproved={isApproved}
            canViewTotal={canViewTotal}
            phaseType={phaseType}
            surfaceType={surfaceType}
            filterLineItems={filterLineItems}
            phaseSource={phaseSource}
          />)}
        </LineItemTable>
        {formError && <MessageBox error message={this.state.errors.note.toString()} />}
      </div>
    </ThemeProvider>);
  }
}

ContractorLaborTable.defaultProps = { lineItemOptions: {}, filterLineItems: false };

ContractorLaborTable.propTypes = {
  phaseId: PropTypes.string,
  appointmentStartDate: PropTypes.string,
  laborSheet: LaborSheetType,
  employableType: PropTypes.string,
  lineItemOptions: PropTypes.object,
  refreshList: PropTypes.func.isRequired,
  savePhaseItem: PropTypes.func.isRequired,
  deletePhaseItem: PropTypes.func.isRequired,
  requestPayRateLineItemList: PropTypes.func.isRequired,
  copyLaborItemsToLaborSheet: PropTypes.func.isRequired,
  total: PropTypes.number,
  index: PropTypes.number,
  editable: PropTypes.bool,
  approvable: PropTypes.bool,
  lpa: PropTypes.bool,
  role: PropTypes.string,
  contractorTableApproved: PropTypes.bool,
  phaseType: PropTypes.string,
  surfaceType: PropTypes.string,
  filterLineItems: PropTypes.bool,
  phaseSource: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => {
  const { employees, user, phase: { details: { type, source, surface_type: { name } } } } = state;
  const contractorTableApproved = ownProps.employableType === 'employee' ?
    employees.byId[user.employable_id].contractor_table_approved : false;
  return {
    lineItemOptions: state.payRateLineItems.data,
    total: getLineItemTotal(ownProps.laborSheet.line_items || []),
    editable: can(getRole(state), 'update', 'contractor_line_item'),
    approvable: can(getRole(state), 'approve', 'labor_sheet'),
    lpa: can(getRole(state), 'update', 'LPA'),
    role: getRole(state),
    contractorTableApproved,
    phaseType: type,
    phaseSource: source,
    surfaceType: name,
  };
};

export default connect(mapStateToProps, {
  savePhaseItem,
  deletePhaseItem,
  requestPayRateLineItemList,
  copyLaborItemsToLaborSheet,
})(ContractorLaborTable);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseAccounting/components/contractorLaborTable.jsx